import React, { useEffect, useState } from "react";
import { getRegions, getDistricts } from "../api/region";

export default function RegionDistrictInput({
  field,
  value,
  formData,
  onChange,
  lang,
}) {
  const [regions, setRegions] = useState([]);
  const [districts, setDistricts] = useState([]);

  // 🔥 загрузка регионов
  useEffect(() => {
    getRegions().then((res) => {
      setRegions(res.data);
    });
  }, []);

  // 🔥 если это район — следим за region
  useEffect(() => {
    if (field.name_ru === "Район") {
      const regionId = formData[6]; // ⚠️ ID поля "Область"

      if (regionId) {
        getDistricts(regionId).then((res) => {
          setDistricts(res.data);
        });
      }
    }
  }, [formData, field.name_ru]);

  // 🟦 Вилоят
  if (field.name_ru === "Область") {
    return (
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">
          {lang === "ru" ? "Выберите область" : "Вилоятро интихоб кунед"}
        </option>

        {regions.map((r) => (
          <option key={r.id} value={r.id}>
            {lang === "ru" ? r.name_ru : r.name_tj}
          </option>
        ))}
      </select>
    );
  }

  // 🟩 Ноҳия
  if (field.name_ru === "Район") {
    return (
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={!formData[6]}
      >
        <option value="">
          {lang === "ru" ? "Выберите район" : "Ноҳияро интихоб кунед"}
        </option>

        {districts.map((d) => (
          <option key={d.id} value={d.id}>
            {lang === "ru" ? d.name_ru : d.name_tj}
          </option>
        ))}
      </select>
    );
  }

  return null;
}
